import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../config/msalConfig";

export const createMsalInstance = async () => {
  const msalInstance = new PublicClientApplication(msalConfig);
  await msalInstance.initialize();
  return msalInstance;
};
